import type { TrailerListing } from '@src/trailer/domain/TrailerList';
import { TrailerClient } from '@src/trailer/service/TrailerClient';
import { useQuery } from '@tanstack/react-query';

export const useTrailer = (clientId: string, trailerId: string) => {
  const { data: trailer, isLoading } = useQuery<TrailerListing>({
    queryKey: ['trailers.get', clientId, trailerId],
    queryFn: () => TrailerClient.get(clientId, trailerId),
  });
  return {
    trailer,
    isLoading,
  };
};
